module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG lead-card"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Lead List")]), _vm._v(" "), _c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-card-text', [_c('div', {
    staticClass: "mt-3"
  }, [_c('b-row', {
    staticClass: "lead_nav align-items-end"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    ref: "search",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search Lead Master and Code"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.common),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "common", $$v)
      },
      expression: "Filter.common"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    staticClass: "col-md-2",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Assigned To")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "id": "assignedTo",
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "Select Assigned User"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.assignedTo),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "assignedTo", $$v)
      },
      expression: "Filter.assignedTo"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "lead_nav align-items-end"
  }, [_c('b-col', {
    staticClass: "col-md-2",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' &&
        _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
        true :
        false
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.branchfilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchfilter", $$v)
      },
      expression: "Filter.branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientId"
    }
  }, [_vm._v("Status Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.StatusTypeList,
      "id": "StatusType",
      "option-value": "val",
      "option-text": "type",
      "placeholder": "Status Type"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.Filter.StatusType),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "StatusType", $$v)
      },
      expression: "Filter.StatusType"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-3",
    attrs: {
      "md": "3"
    }
  }, [_c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('Lead_Master_List', 'Export')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n                  "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.AddLead()
      }
    }
  }, [_vm._v("Add")])], 1)], 1), _vm._v(" "), _c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.LeadList,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection,
      "responsive": "",
      "primary-key": "lead_id"
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "lead_id",
      fn: function(row0) {
        return [_c('span', [_vm._v("\n                    " + _vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage) + "\n                  ")])]
      }
    }, {
      key: "lead_comp_name",
      fn: function(row1) {
        return [(row1.item.lead_comp_name) ? _c('span', [_vm._v(_vm._s(row1.item.lead_comp_name))]) : _vm._e(), _c('br'), _vm._v(" "), _c('div', {
          attrs: {
            "id": 'row' + row1.item.lead_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row1.item.lead_id,
            "name": "approval",
            "value": row1.item.is_converted == 1 ? true : false,
            "disabled": ((_vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh') || (row1.item.is_converted == 1)) ?
              true :
              false
          },
          on: {
            "change": function($event) {
              _vm.isConvertLead(row1.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row1.item.is_converted == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row1.item.is_converted == 1 ? "Converted" : "Pending"))])], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.RaisedFrom) ? _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.RaisedFrom))]) : _vm._e(), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.View_MinutesOfMeeting(row1.item.lead_id)
            }
          }
        }, [_vm._v("View MM")])]
      }
    }, {
      key: "lead_address",
      fn: function(row1) {
        return [(row1.item.lead_address) ? _c('span', [_vm._v("\n                    Address : " + _vm._s(row1.item.lead_address) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.branch_address) ? _c('span', [_vm._v("\n                    Branch Address" + _vm._s(row1.item.branch_address) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.office_address) ? _c('span', [_vm._v("\n                    Office Address" + _vm._s(row1.item.office_address) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "lead_shipmentType",
      fn: function(row2) {
        return [(row2.item.lead_shipmentType) ? _c('span', [_vm._v("\n                    Shipment Type : " + _vm._s(row2.item.lead_shipmentType) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.lead_moduelType) ? _c('span', [_vm._v("\n                    Module Type : " + _vm._s(row2.item.lead_moduelType) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.lead_jobType) ? _c('span', [_vm._v("\n                    Job Type : " + _vm._s(row2.item.lead_jobType) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.lead_container_type) ? _c('span', [_vm._v("\n                    Container Type : " + _vm._s(row2.item.lead_container_type) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.lead_por_exp) ? _c('span', [_vm._v("\n                    Exp/Imp POR : " + _vm._s(row2.item.lead_por_exp) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.lead_pol_exp) ? _c('span', [_vm._v("\n                    Exp/Imp POL : " + _vm._s(row2.item.lead_pol_exp) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row2.item.lead_pod_exp) ? _c('span', [_vm._v("\n                    Exp/Imp POD : " + _vm._s(row2.item.lead_pod_exp) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "is_active",
      fn: function(row3) {
        return [_c('div', {
          attrs: {
            "id": 'row' + row3.item.lead_id
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row3.item.lead_id,
            "name": "approval",
            "value": row3.item.is_active == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateUser(row3.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          attrs: {
            "variant": row3.item.is_active == 1 ? 'success' : 'danger'
          }
        }, [_vm._v(_vm._s(row3.item.is_active == 1 ? "Active" : "In-Active"))])], 1)])], 1), _vm._v(" "), _c('br')]
      }
    }, {
      key: "created_at",
      fn: function(row3) {
        return [(row3.item.created_at) ? _c('span', [_vm._v("\n                    Created : " + _vm._s(row3.item.created_at) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.createdBy) ? _c('span', [_vm._v("\n                    Created By : " + _vm._s(row3.item.createdBy) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.updated_at) ? _c('span', [_vm._v("\n                    Updated : " + _vm._s(row3.item.updated_at) + "\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), (row3.item.updatedBy) ? _c('span', [_vm._v("\n                    Updated By : " + _vm._s(row3.item.updatedBy) + "\n                    "), _c('br')]) : _vm._e()]
      }
    }, {
      key: "action",
      fn: function(row2) {
        return [_c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.editLeadLocation(row2.item)
            }
          }
        }, [_vm._v("Update")]), _vm._v(" "), _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.SendLead(row2.item)
            }
          }
        }, [_vm._v("Send Email")]), _vm._v(" "), _c('b-button', {
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "outline-primary",
            "id": "addButtonLoader",
            "size": "sm"
          },
          on: {
            "click": function($event) {
              _vm.AddLeadTrack(row2.item)
            }
          }
        }, [_vm._v("Add MoM")])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "limit": "25",
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "ViewMinutesOfMeeting-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": "View Minutes Of Meeting"
    }
  }, [_vm._l((_vm.View_MinutesOfMeetingList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "accordion",
      attrs: {
        "role": "tablist"
      }
    }, [_c('b-card', {
      staticClass: "mb-1",
      attrs: {
        "no-body": ""
      }
    }, [_c('b-card-header', {
      staticClass: "p-1",
      attrs: {
        "header-tag": "header",
        "role": "tab"
      },
      on: {
        "click": function($event) {
          _vm.ActiveAccordion(item.activeStatus, index)
        }
      }
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "4"
      }
    }, [_c('b-button', {
      staticClass: "text-left",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'warning' : 'info'
      }
    }, [_vm._v(_vm._s(item.meeting_code))])], 1), _vm._v(" "), _c('b-col', {
      staticClass: "text-center",
      attrs: {
        "cols": "4"
      }
    }, [_c('b-button', {
      staticClass: "text-left",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'warning' : 'info'
      }
    }, [_c('b', [_vm._v("Lead User : ")]), _vm._v(_vm._s(item.lead_user))])], 1), _vm._v(" "), _c('b-col', {
      staticClass: "text-right",
      attrs: {
        "cols": "4"
      }
    }, [_c('b-button', {
      staticClass: "text-right",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'warning' : 'info'
      }
    }, [_vm._v(_vm._s(item.lead_DateTime))])], 1)], 1)], 1), _vm._v(" "), (item.activeStatus) ? _c('b-card-body', [_c('b-card-text', [_c('b', [_vm._v("Lead Date : ")]), _vm._v(_vm._s(item.lead_DateTime) + "\n                                 "), _c('span', {
      staticClass: "text-right"
    }, [_c('b-button', {
      staticClass: "text-left",
      staticStyle: {
        "font-size": "0.675rem"
      },
      attrs: {
        "size": "sm",
        "variant": item.is_followup_done == 0 ? 'danger' : 'success'
      },
      on: {
        "click": function($event) {
          item.is_followup_done == 0 ?
            _vm.FollowupDone(
              item.fk_lead_id,
              item.track_id,
              item.is_followup_done == 0 ? 1 : 0
            ) :
            ''
        }
      }
    }, [_vm._v(_vm._s(item.is_followup_done == 0 ?
      "Followup Pending" :
      "Followup Done"))])], 1)]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Pridel User : ")]), _vm._v(_vm._s(item.lead_pridel_user))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Lead User : ")]), _vm._v(_vm._s(item.lead_user))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Other User : ")]), _vm._v(_vm._s(item.other_lead_user_name))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Lead Venue : ")]), _vm._v(_vm._s(item.lead_venue))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Minutes Of Meeting : ")]), _vm._l((item.lead_minutes_of_meeting.split('\n')), function(line, lineNumber) {
      return _c('span', {
        key: lineNumber
      }, [_vm._v("\n                        " + _vm._s(line)), _c('br')])
    })], 2), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Further Action : ")]), _vm._v(_vm._s(item.lead_further_action))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Followup Date : ")]), _vm._v(_vm._s(item.lead_followupdate))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Followup Time : ")]), _vm._v(_vm._s(item.lead_followupTime))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Assign To : ")]), _vm._v(_vm._s(item.assigned_user_txt))]), _vm._v(" "), _c('b-card-text', [_c('b', [_vm._v("Remark : ")]), _vm._l((item.lead_remark.split('\n')), function(lRemark, rindex) {
      return _c('span', {
        key: rindex
      }, [_vm._v("\n                        " + _vm._s(lRemark)), _c('br')])
    })], 2)], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideViewMinutesOfMeetingModal
    }
  }, [_vm._v("Close\n              ")])], 2)], 1)])], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2042f923","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/Lead/leadList.vue
// module id = 2445
// module chunks = 0